/**
 * Whether two phone numbers are the same line, tolerant of formatting: JustCall reports numbers as
 * bare digits ("14155552671") while we store E.164 ("+14155552671"). Compares the last 10 digits
 * when both sides have at least that many (covers a missing / extra country code), else the full
 * digit strings. Shared so the browser (deciding which JustCall call is ours) and the worker
 * (deciding whether to settle it) can never disagree.
 */
export function phoneNumbersMatch(a: string | null | undefined, b: string | null | undefined): boolean {
  const da = (a ?? '').replace(/\D/g, '');
  const db = (b ?? '').replace(/\D/g, '');
  if (da === '' || db === '') return false;
  if (da.length >= 10 && db.length >= 10) return da.slice(-10) === db.slice(-10);
  return da === db;
}
